/*
 * Назначение: переключатель темы в шапке.
 * Функционал: одна кнопка — клик переключает между светлой и тёмной темой.
 * Простая логика без dropdown, чтобы исключить проблемы с проксированием событий
 * через Radix-меню. Состояние хранит ThemeProvider (localStorage).
 */

import { Moon, Sun } from "lucide-react";

import { Button } from "../ui/button";
import { useTheme } from "./theme-provider";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  const toggle = () => {
    setTheme(isDark ? "light" : "dark");
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={isDark ? "Переключить на светлую тему" : "Переключить на тёмную тему"}
      title={isDark ? "Светлая тема" : "Тёмная тема"}
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </Button>
  );
}
